import handleImagePreview from 'root/common/handleImage';

// 将对象转换成 url参数 ： a=xxx&b=xxx 这样的字符串
export function paramToStr(params = {}) {
    let paramArray = [];
    let keys = Object.keys(params);

    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (params[key] !== undefined) {
            paramArray.push(`${key}=${params[key]}`);
        }
    }
    return paramArray.join('&');
}

/**
 * 包装一个函数，在一定时间里触发了一定次数之后，才触发
 * @param count 次数
 * @param wait 时长
 * @param func 触发的方法
 * @param context 上下文
 */
export function repeatAfter(count, wait, func, context = null) {
    let timer = null;
    let num = 0;
    return function(...args) {
        // 清空timer
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        // 增加数量
        num++;
        console.log(`tap num --> ${num}`);
        if (num >= count) {
            func.apply(context, args);
        }

        // 多少秒后还未进入就清0
        timer = setTimeout(() => {
            num = 0;
        }, wait);
    };
}

// 从 location.search 中获取 query 参数
export function getQuery(search) {
    var queryObj = new Object();
    if (search.indexOf('?') != -1) {
        var params = search.substr(1);
        params = params.split('&');
        for (var i = 0; i < params.length; i++) {
            let query = params[i].split('=');
            queryObj[query[0]] = query[1];
        }
    }
    return queryObj;
}

/**
 * 打开页面
 * to : { path , query }
 * 注意： 不支持 params
 */
export function getFullUrl(to) {
    let routeObj = { ...to };
    const origin = window.location.origin;
    const pathName = window.location.pathname;
    let link = `${origin}${pathName}?ZZCAppArg=AppOpenPage#${routeObj.path}`;
    let query = to.query || {};
    let queryStr = paramToStr(query);
    if (queryStr) {
        link += `?${queryStr}`;
    }
    return link;
}

/**
 * 是否ios
 */
export function isIos() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS;
}

//判断是否使用微信app支付
//iosMinVersion 最低兼容版本 格式1.3.0
//androidMinVersion 最低兼容版本 格式1.5.0
export function isGreaterVersion({ iosMinVersion, androidMinVersion }) {
    let minVersion;
    let ua = window.navigator.userAgent;
    let isIos = /ZZCIOS\/black/.test(ua);
    let isAndroid = /ZZCAndroid\/black/.test(ua);
    if (isIos) {
        minVersion = iosMinVersion;
    } else if (isAndroid) {
        minVersion = androidMinVersion;
    } else {
        return false;
    }
    let minVersionArray = minVersion.split('.');
    let versionArray =
        ua
            .split('(')[0]
            .split('/')[2]
            .split('.') || [];
    if (Number(versionArray[0]) > minVersionArray[0]) {
        return true;
    } else if (Number(versionArray[1]) >= minVersionArray[1]) {
        return true;
    } else {
        return false;
    }
}

/**
 * 前面补零
 * @param {*} num
 */
export function fillZero(num) {
    if (num > 9) {
        return `${num}`;
    } else {
        return `0${num}`;
    }
}

/**
 * 对秒数进行格式化
 * @param {*} time
 */
export function timeFormat(time) {
    let timeMunites = Math.floor(time / 60);
    let timeSeconds = Math.round(time - timeMunites * 60);
    let munites = fillZero(timeMunites);
    let seconds = fillZero(timeSeconds);
    return { munites, seconds };
}

export function noop() {}

//倒计时
export function timeDown({ time, count, done }) {
    if (time === 0) {
        done();
        return;
    }
    count(time);
    setTimeout(() => {
        time--;
        timeDown({ time, count, done });
    }, 1000);
}

// 获取当前url上的查询参数
export function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

// 获取元素的scrollTop
export function getScrollTop(element) {
    if (element === window) {
        return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
    }
    return element.scrollTop;
}

//设置scrollTop
export function setScrollTop(element, scrollTop) {
    'scrollTop' in element ? (element.scrollTop = scrollTop) : element.scrollTo(element.scrollX, scrollTop);
}

export function jsonParse(str, defaultValue = {}) {
    try {
        let obj = JSON.parse(str);
        return obj;
    } catch (error) {
        return defaultValue;
    }
}

/**
 * 获取剩余时间 , 以下时间都是时间戳 13位的 ms
 * @param  {Number} endTime    截止时间
 * @param  {Number} deviceTime 设备时间
 * @param  {Number} serverTime 服务端时间
 * @return {Object}            剩余时间对象
 */
export function getRemainTime(endTime, deviceTime, serverTime) {
    const time = endTime - new Date().getTime() + (deviceTime - serverTime); // 一开始服务端的时间和客户端的时间差异
    // console.log(`deviceTime - serverTime-- > ${deviceTime - serverTime}`)
    return time;
}

/**
 * 格式化时间
 */
export function formatTime(time) {
    const millisecond = Math.floor(time % 1000);
    const seconds = Math.floor((time / 1000) % 60);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    return { days, hours, minutes, seconds, millisecond };
}

/**
 * 格式化时间时分秒
 */
export function formatTimeOfHour(time) {
    const millisecond = Math.floor(time % 1000);
    const seconds = Math.floor((time / 1000) % 60);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const hours = Math.floor(time / (1000 * 60 * 60));
    return { hours, minutes, seconds, millisecond };
}

export function patchPosition(num) {
    if (num >= 10) {
        return num;
    } else {
        return '0' + num;
    }
}

export const isApp = window.__is_blackApp;

// 设置页面分享信息
export function setShareInfo({ title, img, desc, link }) {
    let shareInfo = {};
    let imgUrl = handleImagePreview(img, '200x0') || '';
    shareInfo.title = title;
    shareInfo.desc = desc || '商城商品限时折扣，低至5折，速看>>';
    shareInfo.link = link || window.location.href;

    shareInfo.imgUrl = imgUrl.indexOf('https') < 0 ? 'https:' + imgUrl : imgUrl;
    shareInfo.success = function() {
        if (!isApp) window.ZZCFL.Toast('分享成功');
    };
    window.ZZCSHARE.start({ shareInfo: shareInfo, target: 'onMenuShareAppMessage' });
    window.ZZCSHARE.start({ shareInfo: shareInfo, target: 'onMenuShareTimeline' });
    console.log('shareInfo --> ', shareInfo);
}
